import React, { useState, useEffect } from "react";

const Alert = (props) => {
  const [display, setDisplay] = useState("");

  useEffect(() => {
    if (props.isCleared) {
      const text =
        "Well Done Mrs. Tandukar. Now, it's time to get your hands dirty in the kitchen.";
      let i = 0;
      const timer = setInterval(() => {
        setDisplay(text.substring(0, i));
        i++;
        if (i > text.length) {
          clearInterval(timer);
        }
      }, 50);
    }
  }, [props.isCleared]);

  return (
    <>{props.isCleared ? <h2 className="alertText">{display}</h2> : null}</>
  );
};

export default Alert;
